//import { Notification } from "element-ui";
import { api } from "../../gateways/unilabCiprianiApi";

export default {
  getProfile() {
    return new Promise((resolve, reject) => {
      api
        .get("phe-geometry/profiles")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          // title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getCalculationType() {
    return new Promise((resolve, reject) => {
      api
        .get("phe-geometry/calculation_type")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getCalculationMode() {
    return new Promise((resolve, reject) => {
      api
        .get("phe-geometry/calculation_mode")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            // title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getTypeOfPhe() {
    return new Promise((resolve, reject) => {
      api
        .get("phe-geometry/type_of_phe")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          // title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getDesignStandard() {
    return new Promise((resolve, reject) => {
      api
        .get("phe-geometry/design_standard")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getProductLine(idPheType, idCalculationMode) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "phe-geometry/product_line?IdPheType=" +
            idPheType +
            "&IdCalculationMode=" +
            idCalculationMode
        )
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getDesignPressure(idTipoCalcolo, idPheType, idLinea) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "phe-geometry/design_pressure?IdTipoCalcolo=" +
            idTipoCalcolo +
            "&IdPheType=" +
            idPheType +
            "&IdLinea=" +
            idLinea
        )
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getPlatesMaterial(idTipoCalcolo, modalita, idPheType, idStandard, idLinea, idPressione) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "phe-geometry/plates_material" +
            "?IdTipoCalcolo=" +
            idTipoCalcolo +
            "&Modalita=" +
            modalita +
            "&IdPheType=" +
            idPheType +
            "&IdStandard=" +
            idStandard +
            "&IdLinea=" +
            idLinea +
            "&IdPressione=" +
            idPressione
        )
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getPlatesThickness(idPheType, idTaglia) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "phe-geometry/plates_thickness" +
            /*"?IdProfilo=" +
            idProfilo +
            "&IdTipoCalcolo=" +
            idTipoCalcolo +*/
            "?IdPheType=" +
            idPheType +
            "&IdTaglia=" +
            idTaglia
        )
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getPlatesThicknessNew(idPheType, designStandardValue, productLineValue, idTaglia) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "phe-geometry/plates_thickness_new" +
            /*"?IdProfilo=" +
            idProfilo +
            "&IdTipoCalcolo=" +
            idTipoCalcolo +*/
            "?IdPheType=" +
            idPheType +
            "&designStandardValue=" +
            designStandardValue +
            "&productLineValue=" +
            productLineValue +
            "&IdTaglia=" +
            idTaglia
        )
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getGasketsMaterial(
    idTipoCalcolo,
    modalita,
    idPheType,
    idStandard,
    idLinea,
    idPressione,
    designTempEnabled,
    ts,
    tsums,
    leftPanel,
    rightPanel,
    activeValue
  ) {
    var gmvm = {};
    gmvm.idTipoCalcolo = idTipoCalcolo;
    gmvm.modalita = modalita;
    gmvm.idPheType = idPheType;
    gmvm.idStandard = idStandard;
    gmvm.idLinea = idLinea;
    gmvm.idPressione = idPressione;
    gmvm.designTempEnabled = designTempEnabled;
    gmvm.ts = ts;
    gmvm.tsums = tsums;
    gmvm.left = leftPanel;
    gmvm.right = rightPanel;
    gmvm.activeValue = activeValue;
    return new Promise((resolve, reject) => {
      api
        .post("phe-geometry/gaskets_material", gmvm)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            // title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getCalculateTS(idTipoCalcolo, modalita, designTempEnabled, ts, tsums, leftPanel, rightPanel) {
    var gmvm = {};
    gmvm.idTipoCalcolo = idTipoCalcolo;
    gmvm.modalita = modalita;
    gmvm.idPheType = 0;
    gmvm.idStandard = 0;
    gmvm.idLinea = 0;
    gmvm.idPressione = 0;
    gmvm.designTempEnabled = designTempEnabled;
    gmvm.ts = ts;
    gmvm.tsums = tsums;
    gmvm.left = leftPanel;
    gmvm.right = rightPanel;

    return new Promise((resolve, reject) => {
      api
        .post("phe-geometry/calculate_ts", gmvm)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getFramesMaterial(
    idTipoCalcolo,
    modalita,
    idPheType,
    idStandard,
    idLinea,
    idPressione,
    idTaglia
  ) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "phe-geometry/frames_material" +
            "?IdTipoCalcolo=" +
            idTipoCalcolo +
            "&Modalita=" +
            modalita +
            "&IdPheType=" +
            idPheType +
            "&IdStandard=" +
            idStandard +
            "&IdLinea=" +
            idLinea +
            "&IdPressione=" +
            idPressione +
            "&IdTaglia=" +
            idTaglia
        )
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getSizeGeometry(
    idTipoCalcolo,
    idStandard,
    idLinea,
    idPressione,
    idMAT_T,
    idMAT_P,
    idMAT_G,
    idSpessore,
    idPheType
  ) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "phe-geometry/size_geometry" +
            "?IdTipoCalcolo=" +
            idTipoCalcolo +
            /*"&IdPheType=" +
            idPheType +*/
            "&IdStandard=" +
            idStandard +
            "&IdLinea=" +
            idLinea +
            "&IdPressione=" +
            idPressione +
            "&IdMAT_T=" +
            idMAT_T +
            "&IdMAT_P=" +
            idMAT_P +
            "&IdMAT_G=" +
            idMAT_G +
            "&IdSpessore=" +
            idSpessore +
            "&idPheType=" +
            idPheType
        )
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  scambiatoreDaCodice(code, idCodiceTipo) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "phe-geometry/scambiatoreDaCodice" +
            "?code=" +
            code.replace("#", "[*1*]").replace("+", "[*2*]") +
            "&idCodiceTipo=" +
            idCodiceTipo
        )
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          // message: error
          //});
          reject(error);
        });
    });
  },

  getTypeGeometry(idTipoCalcolo, idPheType, idLinea, idTaglia) {
    return new Promise((resolve, reject) => {
      api
        .get(
          "phe-geometry/type_geometry" +
            "?IdTipoCalcolo=" +
            idTipoCalcolo +
            "&IdPheType=" +
            idPheType +
            "&IdLinea=" +
            idLinea +
            "&IdTaglia=" +
            idTaglia
        )
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getHighPerformancePlatePercentageValues(modalita) {
    return new Promise((resolve, reject) => {
      api
        .get("phe-geometry/high_performance_values?modalita=" + modalita)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },

  getPlateChannelTypeCodeById(id) {
    return new Promise((resolve, reject) => {
      api
        .get("phe-geometry/channel_type_code_by_id?id=" + id)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  }
};
